import { useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Dialog, DialogContent, DialogTitle } from '@/shared/components/ui/dialog'

type LightboxItem = { fileId: string; name: string; url: string }

export function AttachmentLightbox({
  items,
  index,
  onIndexChange,
  onClose,
}: {
  items: LightboxItem[]
  index: number | null
  onIndexChange: (index: number) => void
  onClose: () => void
}) {
  useEffect(() => {
    if (index === null) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'ArrowRight') onIndexChange((index + 1) % items.length)
      if (event.key === 'ArrowLeft') onIndexChange((index - 1 + items.length) % items.length)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [index, items.length, onIndexChange])

  if (index === null || !items[index]) return null
  const item = items[index]

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl p-2">
        <DialogTitle className="sr-only">{item.name}</DialogTitle>
        <div className="relative flex items-center justify-center">
          {items.length > 1 && (
            <button
              type="button"
              aria-label="Previous attachment"
              onClick={() => onIndexChange((index - 1 + items.length) % items.length)}
              className="absolute left-2 rounded-md bg-surface/80 p-1.5 text-ink-2 hover:bg-surface"
            >
              <ChevronLeft size={18} />
            </button>
          )}
          <img src={item.url} alt={item.name} className="max-h-[78vh] w-auto rounded-md" />
          {items.length > 1 && (
            <button
              type="button"
              aria-label="Next attachment"
              onClick={() => onIndexChange((index + 1) % items.length)}
              className="absolute right-2 rounded-md bg-surface/80 p-1.5 text-ink-2 hover:bg-surface"
            >
              <ChevronRight size={18} />
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
